import {useDispatch, useSelector} from "react-redux";
import s from "../product.module.css";
import StarRating from "../../../../assets/Components/rating/StarRating";
import BuyButton from "../../../../assets/Components/StyledComponents/BuyButton";
import {useState} from "react";
import {addReview} from "../../../../store/SetProductSlice";

const ProductTabReview = () => {
    const reviews = useSelector(state => state.setProduct.reviews);
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");
    const dispatch = useDispatch();

    const formSubmit = (e) => {
        dispatch(addReview({name: name, text: message}));
        e.preventDefault();
        setName("");
        setMessage("");
    }

    return (
        <div id="review" className={s.tabReview}>
            {
                reviews.map(el => {
                    return <div key={el.id} className={s.review}>
                        <div className={s.reviewTitle}><h3>{el.name}</h3>
                            <StarRating/>
                        </div>
                        <p>{el.text}</p>
                    </div>
                })
            }
            <div className={s.makeReview}>
                <h3>НАПИСАТЬ ОТЗЫВ</h3>
                <form onSubmit={formSubmit} className={s.reviewForm}>
                    <div>
                        <h5>Ваше имя</h5>
                        <input value={name} onChange={(e) => setName(e.target.value)} name="name" type="text"/>
                    </div>
                    <div className={s.reviewFormText}>
                        <h5>Ваш отзыв</h5>
                        <textarea value={message} onChange={(e) => setMessage(e.target.value)} name="message"
                                  placeholder="Ваше сообщение..."/>
                    </div>
                    <div>
                        <h5>Оценка</h5>
                        <StarRating/>
                    </div>
                    <BuyButton type="submit">Оставить отзыв</BuyButton>
                </form>
            </div>
        </div>
    )
}

export default ProductTabReview;